import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData, getList } from '../../helpers/fackBackend_Helper';

function* releaseLockSimSwapRequestResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/releaseLockSimSwapRequest', data);
        if (response.Status) {
            yield put(actions.releaseLockSimSwapRequestSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            yield put(actions.releaseLockSimSwapRequestFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.releaseLockSimSwapRequestFailed(error.Message));
    }
}

function* lockSimSwapRequestResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/lockSimSwapRequest', data);
        if (response.Status) {
            yield put(actions.lockSimSwapRequestSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            if (response.LockedByUser) {
                yield put(actions.lockSimSwapRequestFailed(`${response.Message} by ${response.LockedByUser}`));
            } else {
                yield put(actions.lockSimSwapRequestFailed(response.Message));
            }
        }
    } catch (error) {
        yield put(actions.lockSimSwapRequestFailed(error.Message));
    }
}

function* getSimSwapRequestResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/simSwapRequestList', searchData);
        if (response.Status) {
            yield put(actions.getSimSwapRequestSuccess(response.Data));
        } else {
            yield put(actions.getSimSwapRequestFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.getSimSwapRequestFailed(error.Message));
    }
}

function* getActivationDetailsResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/activationDetailsByMsisdn', searchData);
        if (response.Status) {
            yield put(actions.getActivationDetailsByMsisdnSuccess(response.Data));
        } else {
            yield put(actions.getActivationDetailsByMsisdnFailed('No data available'));
        }
    } catch (error) {
        yield put(actions.getActivationDetailsByMsisdnFailed(error.Message));
    }
}

function* createSimSwapRequestResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/simSwapRequest', data);
        if (response.Status) {
            yield put(actions.createSIMSwapRequestSuccess(response.Data));

        } else {
            yield put(actions.createSIMSwapRequestFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.createSIMSwapRequestFailed(error.Message));
    }
}

function* cancelSimSwapRequestResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/cancelSimSwapRequest', data);
        if (response.Status) {
            yield put(actions.cancelSimSwapRequestSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            yield put(actions.cancelSimSwapRequestFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.lockSimSwapRequestFailed(error.Message));
    }
}

function* completeSimSwapRequestResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/completeSimSwapRequest', data);
        if (response.Status) {
            yield put(actions.completeSimSwapRequestSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            yield put(actions.completeSimSwapRequestFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.completeSimSwapRequestFailed(error.Message));
    }
}

function* getOtpResponse({ payload: { swapId } }) {
    try {
        const response = yield call(getList, '/getSwapOtp/' + swapId);
        if (response.response.Status) {
            yield put(actions.getOTPSuccess(response.response.Data));
        } else {
            yield put(actions.getOTPFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getOTPFailed(error.Message));
    }
}

function* checkSimSwapCompletion({ payload: { swapId } }) {
    try {
        const response = yield call(getList, '/checkSimSwapCompletionStatus/' + swapId);
        if (response.Status) {
            yield put(actions.checkSimSwapCompletionSuccess(response.Message));
        } else {
            yield put(actions.checkSimSwapCompletionFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.checkSimSwapCompletionFailed(error.Message));
    }
}

function* getMDNResponse({ payload: { mdn } }) {
    try {
        const response = yield call(addData, '/getTopMSISDNList/' + mdn);
        if (response.response.Status) {
            yield put(actions.getMsisdnAvilableSuccess(response.response.data, response.response.data[0].Message));
        } else {
            yield put(actions.getMsisdnAvilableFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getMsisdnAvilableFailed(error.Message));
    }
}

function* pickedMsisdnupdateResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/updatepickedmsisdn', data);
        if (response.Status) {
            yield put(actions.updatePickedMsisdnSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            yield put(actions.updatePickedMsisdnFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.updatePickedMsisdnFailed(error.Message));
    }
}

function* createActivationUsingDailyPlanResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/createActivationUsingSimSwap', data);
        if (response.Status) {
            yield put(actions.createActivationUsingSimSwapSuccess(response.Message));
            yield put(actions.getSimSwapRequest(searchData));
        } else {
            yield put(actions.createActivationUsingSimSwapFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.createActivationUsingSimSwapFailed(error.message));
    }
}

function* updateSIMSWapRequestStatusResponse({ payload: { updateData, data } }) {
    try {
        const response = yield call(addData, '/updateSImSwapRequestStatus', updateData);
        if (response.response.Status) {
            yield put(actions.updateSIMSwapRequestStatusSuccess(response.response.Message, data.activationId));
            yield put(actions.getSimSwapRequest(data))
        } else {
            yield put(actions.updateSIMSwapRequestStatusFailed(response.response.Message, data.activationId));
            yield put(actions.getSimSwapRequest(data))
        }
    } catch (error) {
        yield put(actions.updateSIMSwapRequestStatusFailed(error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.GET_SIM_SWAP_REQUEST, getSimSwapRequestResponse)]);
    yield all([takeEvery(actions.LOCK_SIM_SWAP_REQUEST, lockSimSwapRequestResponse)]);
    yield all([takeEvery(actions.RELEASE_LOCK_SIM_SWAP_REQUEST, releaseLockSimSwapRequestResponse)]);
    yield all([takeEvery(actions.CANCEL_SIM_SWAP_REQUEST, cancelSimSwapRequestResponse)]);
    yield all([takeEvery(actions.COMPLETE_SIM_SWAP_REQUEST, completeSimSwapRequestResponse)]);
    yield all([takeEvery(actions.GET_OTP, getOtpResponse)]);
    yield all([takeEvery(actions.CHECK_SIM_SWAP_COMPLETION, checkSimSwapCompletion)]);
    yield all([takeEvery(actions.GET_ACTIVATION_DETAILS_BY_MSISDN, getActivationDetailsResponse)]);
    yield all([takeEvery(actions.CREATE_SIM_SWAP_REQUEST, createSimSwapRequestResponse)]);
    yield all([takeEvery(actions.GET_MSISDN_AVAILABLE, getMDNResponse)]);
    yield all([takeEvery(actions.UPDATE_PICKED_MSISDN, pickedMsisdnupdateResponse)]);
    yield all([takeEvery(actions.CREATE_ACTIVATION_USING_SIM_SWAP, createActivationUsingDailyPlanResponse)]);
    yield all([takeEvery(actions.UPDATE_SIM_SWAP_REQUEST_STATUS, updateSIMSWapRequestStatusResponse)]);
}